import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import Footer from '../components/Footer';
import FloatingThemeToggle from '../components/FloatingThemeToggle';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  const handleTwitchLogin = () => {

    // Redirect to the backend auth endpoint using the API URL from environment
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.waddup.me';
    window.location.href = `${apiUrl}/auth/twitch`;
  };

  return (
    <>
      <FloatingThemeToggle />
      {/* Main content area */}
      <div className="bg-gradient-to-br from-gray-900 light:from-gray-50 via-gray-800 light:via-gray-100 to-twitch-900 light:to-twitch-100 flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 py-8">
          <div className="text-center">
            <div className="flex justify-center">
              <ChatBubbleLeftRightIcon className="h-16 w-16 text-twitch-600" />
            </div>
            <h2 className="mt-6 text-3xl font-extrabold text-white light:text-gray-900">
              {t('login.title')}
            </h2>
            <p className="mt-2 text-sm text-gray-400 light:text-gray-600">
              {t('login.subtitle')}
            </p>
          </div>

          <div className="mt-8 space-y-6">
            <div className="text-center">
              <button
                onClick={handleTwitchLogin}
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-twitch-600 hover:bg-twitch-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-twitch-500 transition-colors duration-200"
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg className="h-5 w-5 text-twitch-300 group-hover:text-twitch-400" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z"/>
                  </svg>
                </span>
                {t('login.button')}
              </button>
            </div>

            <div className="mt-6">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-600 light:border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-gradient-to-br from-gray-900 light:from-gray-50 via-gray-800 light:via-gray-100 to-twitch-900 light:to-twitch-100 text-gray-400 light:text-gray-600">Features</span>
                </div>
              </div>

              <div className="mt-6 grid grid-cols-1 gap-4">
                <div className="text-center p-4 bg-gray-800/50 light:bg-white/50 backdrop-blur-sm rounded-lg border border-gray-700 light:border-gray-300">
                  <h3 className="text-lg font-medium text-white light:text-gray-900 mb-2">{t('home.features.realtime.title')}</h3>
                  <p className="text-sm text-gray-400 light:text-gray-600">
                    {t('home.features.realtime.description')}
                  </p>
                </div>
                
                <div className="text-center p-4 bg-gray-800/50 light:bg-white/50 backdrop-blur-sm rounded-lg border border-gray-700 light:border-gray-300">
                  <h3 className="text-lg font-medium text-white light:text-gray-900 mb-2">Greeting Checklist</h3>
                  <p className="text-sm text-gray-400 light:text-gray-600">
                    Mark chatters as greeted with a simple click
                  </p>
                </div>
                
                <div className="text-center p-4 bg-gray-800/50 light:bg-white/50 backdrop-blur-sm rounded-lg border border-gray-700 light:border-gray-300">
                  <h3 className="text-lg font-medium text-white light:text-gray-900 mb-2">{t('home.features.obs.title')}</h3>
                  <p className="text-sm text-gray-400 light:text-gray-600">
                    {t('home.features.obs.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center text-xs text-gray-500 mt-4">
              {t('login.footer')}
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </>
  );
};

export default LoginPage; 